var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Background'),_c('Countdown',{attrs:{"target-date":_vm.targetDate}}),_c('Renderer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }